/** @jsxImportSource @emotion/react */
import {
  createStyles,
  Modal,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { useNavigate } from 'react-router-dom';
import { useDeleteCase } from 'api/useCasesApi';

interface Props {
  caseId: string;
  onClose: () => void;
}

export const DeleteCaseModal = ({ caseId, onClose }: Props) => {
  const styles = useStyles();
  const { palette } = useTheme();
  const navigate = useNavigate();

  const deleteMutation = useDeleteCase(caseId);

  const handleDelete = () => {
    deleteMutation.mutate(undefined, {
      onSuccess: () => {
        onClose();
        void navigate('/fcu/cases');
      },
    });
  };

  return (
    <Modal
      title="Delete Case"
      primaryButtonProps={{
        text: deleteMutation.isPending ? 'Deleting...' : 'Delete',
        onClick: handleDelete,
        disabled: deleteMutation.isPending,
        loading: deleteMutation.isPending,
      }}
      secondaryButtonProps={{
        text: 'Cancel',
        onClick: onClose,
      }}
    >
      <div css={styles.container}>
        <Typography variant="body">
          Are you sure you want to delete this case? This action cannot be
          undone.
        </Typography>
        {deleteMutation.error && (
          <Typography variant="bodySmall" color={palette.danger.default}>
            {deleteMutation.error.errorMessage ?? 'Failed to delete case'}
          </Typography>
        )}
      </div>
    </Modal>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
}));
